import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import { getUserRole, UserRoleName } from './authRole';

const AdminRoleWrapper = ({ children, roleAllowed }: { children: any; roleAllowed: UserRoleName | UserRoleName[] }) => {
    const user: any = useSelector<any>((state: RootState) => state.auth.data);

    const role = getUserRole(user);
    const allowedRoles = Array.isArray(roleAllowed) ? roleAllowed : [roleAllowed];
    if (!allowedRoles.includes(role)) {
        return null;
    }
    return children;
};

export default AdminRoleWrapper;
